<mat-dialog-content class="text-center">
  <div class="container-popup">
    <div class="header">
      <span class="header-title">Update Profile</span>
      <span class="header-close">
        <button mat-icon-button (click)="onCancel()">
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </div>

    <form #formRef="ngForm">
      <div *ngIf="profile">
        <div class="field">
          <label for="firstName">First Name</label>
          <input
            id="firstName"
            type="text"
            name="firstName"
            maxlength="50"
            [(ngModel)]="profile.firstName"
            required
            class="w-full"
            #firstNameRef="ngModel"
          />
          <div class="error" *ngIf="firstNameRef.invalid && firstNameRef.touched">First name is required</div>
        </div>

        <div class="field">
          <label for="lastName">Last Name</label>
          <input
            id="lastName"
            type="text"
            name="lastName"
            maxlength="50"
            [(ngModel)]="profile.lastName"
            required
            class="w-full"
            #lastNameRef="ngModel"
          />
          <div class="error" *ngIf="lastNameRef.invalid && lastNameRef.touched">Last name is required</div>
        </div>

        <div class="field">
          <label for="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            [(ngModel)]="profile.email"
            required
            email
            class="w-full"
            #emailRef="ngModel"
          />
          <div class="error" *ngIf="emailRef.invalid && emailRef.touched">
            <span *ngIf="emailRef.errors?.['required']">Email is required</span>
            <span *ngIf="emailRef.errors?.['email']">Invalid email format</span>
          </div>
        </div>

        <div class="field">
          <label for="zip">Zip Code</label>
          <input
            id="zip"
            type="text"
            name="zipCode"
            [(ngModel)]="profile.zip"
            maxlength="5"
            pattern="^[0-9]{5}$"
            required
            class="w-full"
            #zipRef="ngModel"
          />
          <div class="error" *ngIf="zipRef.invalid && zipRef.touched">
            <span *ngIf="zipRef.errors?.['required']">Zip code is required</span>
            <span *ngIf="zipRef.errors?.['pattern']">Enter a valid 5-digit zip code</span>
          </div>
        </div>

        <div class="field">
          <label for="gender">Gender</label>
          <div class="gender-toggle">
            <button
              type="button"
              [class.active]="profile.gender === 'M'"
              (click)="profile.gender = 'M'"
            >
              Male <span *ngIf="profile.gender === 'M'">✔</span>
            </button>
            <button
              type="button"
              [class.active]="profile.gender === 'F'"
              (click)="profile.gender = 'F'"
            >
              Female <span *ngIf="profile.gender === 'F'">✔</span>
            </button>
          </div>
        </div>
        
        <div class="field">
          <label for="dob">Date of Birth</label>
          <mat-form-field appearance="outline" class="w-full custom-date-field">
            <input
              matInput
              id="dob"
              name="dob"
              [matDatepicker]="picker"
              placeholder="Choose DOB"
              [(ngModel)]="profile.dateOfBirth"
              required
              #dobRef="ngModel"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <div class="error" *ngIf="dobRef.invalid && dobRef.touched">
            Date of birth is required
          </div>
        </div>
        

        <div class="field">
          <label for="phoneNumber">Phone Number</label>
          <input
            id="phoneNumber"
            name="phoneNumber"
            [(ngModel)]="profile.phoneNumber"
            (ngModelChange)="onPhoneNumberChange($event)"
            maxlength="12"
            required
            class="w-full"
            #phoneRef="ngModel"
          />
          <div class="error" *ngIf="phoneRef.invalid && phoneRef.touched">Phone number is required</div>
          <div class="error" *ngIf="phoneRef.errors?.['maxlength'] && phoneRef.touched">Phone number must be 10 digits long</div>
        </div>

        <div class="field">
          <label for="password">Old Password</label>
          <input
            id="password"
            type="password"
            name="password"
            [(ngModel)]="profile.password"
            required
            minlength="6"
            class="w-full"
            #passwordRef="ngModel"
          />
          <div class="error" *ngIf="passwordRef.errors?.['required'] && passwordRef.touched">Password is required</div>
          <div class="error" *ngIf="passwordRef.errors?.['minlength'] && passwordRef.touched">Minimum 6 characters</div>
        </div>

        <div class="d-flex justify-content-between">
          <button
            type="submit"
            class="registerBtn create-btn w-50"
            [disabled]="formRef.invalid"
            (click)="onSave()"
          >
            <span><mat-icon>check</mat-icon></span>
            <span>Update</span>
          </button>
          <button type="button" mat-button (click)="onCancel()" class="cancel-btn w-50 text-white">Cancel</button>
          
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
